import React from 'react';
// logic
import { useHistory } from 'react-router-dom';
// icons
import { ReactComponent as NewIcon } from 'assets/icons/new.svg';
import ToolBarButton from '../ui/toolbar/toolBarButton';
// components
import ToolbarContainer from '../ui/containers/toolbarContainer';
import FlexContainer from '../ui/containers/flexContainer';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import ticketService from 'modules/emergencies/ticketService';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

const t = {
  filter_views: 'Filter views',
  new_filter_view: 'New filter view',
};
const FilterViewsListToolbar = () => {
  const history = useHistory();

  return (
    <ToolbarContainer>
      <FlexContainer>
        <ToolbarTitle>{t.filter_views}</ToolbarTitle>
      </FlexContainer>
      <FlexContainer>
        <ToolBarButton
          withBorder={true}
          onClick={() => {
            history.push('/emergencies/filter-views/new');
          }}
        >
          <NewIcon />
          {t.new_filter_view}
        </ToolBarButton>
        <ToolBarButton
          withBorder={true}
          onClick={() => {
            ticketService.utils.navigateToList({ history });
          }}
        >
          <CloseIcon />
        </ToolBarButton>
      </FlexContainer>
    </ToolbarContainer>
  );
};

export default FilterViewsListToolbar;
